import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, Teleport as _Teleport, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d6ca370"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "form"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-search" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "form"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-search" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  class: "form"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "rk_filter" }, "Bénévolat / aide", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "rk_filter" }, "Recomandations", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "rk_filter" }, "Partager des connaissances", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-search" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "form"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-search" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "form"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-search" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 2,
  class: "form"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "rk_filter" }, "Bénévolat / aide", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "rk_filter" }, "Recomandations", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "rk_filter" }, "Partager des connaissances", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-search" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  class: "categories_section"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = { class: "rk_home_video" }
const _hoisted_29 = {
  key: 0,
  autoplay: "",
  muted: "",
  loop: "",
  id: "myVideo",
  preload: "metadata"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("Tout ce que tu cherches près de chez toi… "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" En un clic,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" kikekoi le trouve ! ")
], -1))
const _hoisted_32 = ["src"]
const _hoisted_33 = ["src"]
const _hoisted_34 = {
  key: 0,
  class: "rk_titre_section"
}
const _hoisted_35 = {
  key: 1,
  class: "rk_titre_section entraide"
}
const _hoisted_36 = { class: "elements" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "rk_result_prese" }
const _hoisted_39 = { class: "rk_titre_card" }
const _hoisted_40 = { class: "rk_presentation_card" }
const _hoisted_41 = { class: "rk_titre_position" }
const _hoisted_42 = ["src"]
const _hoisted_43 = {
  key: 1,
  class: "rk_no_prest"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Oh non ! 🥺 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Nous ne trouvons aucun prestataire autour de chez vous pour le moment... ")
], -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  key: 2,
  class: "rk_mise_en_avant"
}
const _hoisted_47 = { class: "rk_container" }
const _hoisted_48 = { class: "rk_titre_section" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "84",
  height: "76",
  viewBox: "0 0 84 76",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { opacity: "0.103" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M43.32 7.10007C45.3268 4.97147 47.7556 3.28503 50.4513 2.14857C53.1469 1.01212 56.05 0.45065 58.975 0.500071C72.744 0.500071 83.495 11.6281 83.495 27.4721C83.495 36.9031 78.78 44.8251 70.295 53.3131C68.404 55.2001 62.748 60.2921 62.559 60.4801C61.805 61.2341 60.859 61.9891 59.918 62.9321C58.786 63.8751 57.466 65.0071 56.334 65.9501C53.693 68.2131 50.864 70.2881 48.034 72.3631C47.1182 73.0084 46.2367 73.701 45.393 74.4381C45.0007 74.6662 44.6227 74.918 44.261 75.1921C43.6312 75.6516 42.8717 75.8992 42.092 75.8992C41.3124 75.8992 40.5529 75.6516 39.923 75.1921C39.5614 74.918 39.1833 74.6662 38.791 74.4381C38.037 73.8721 37.091 73.1181 36.15 72.3631C33.321 70.2881 30.491 68.0251 27.85 65.9501C26.53 64.8181 25.398 63.8751 24.266 62.9321C23.323 62.1781 22.566 61.2321 21.625 60.4801C21.248 60.2911 15.589 55.1991 13.703 53.3131C5.03103 44.8251 0.504028 36.9001 0.504028 27.4721C0.504028 11.6281 11.255 0.500071 25.024 0.500071C27.949 0.45065 30.8521 1.01212 33.5478 2.14857C36.2434 3.28503 38.6723 4.97147 40.679 7.10007C41.165 7.49154 41.6076 7.93408 41.999 8.42007C42.3905 7.93408 42.833 7.49154 43.319 7.10007H43.32ZM43.504 66.5161C46.145 64.4411 48.974 62.3661 51.426 60.2921C52.6409 59.3819 53.7782 58.3724 54.826 57.2741C55.6861 56.5674 56.5048 55.8118 57.278 55.0111C57.655 54.6341 63.314 49.5411 65.011 47.8441C72.178 40.6771 75.951 34.4521 75.951 27.4731C75.951 15.7791 68.406 8.04507 58.975 8.04507C55.0833 8.07699 51.3595 9.63461 48.604 12.3831C47.6745 13.2929 46.8509 14.305 46.149 15.4001C45.772 15.9661 45.583 16.5321 45.395 16.7201C45.0943 17.3942 44.6047 17.9668 43.9854 18.3687C43.3661 18.7705 42.6437 18.9843 41.9055 18.9843C41.1673 18.9843 40.4449 18.7705 39.8257 18.3687C39.2064 17.9668 38.7168 17.3942 38.416 16.7201C38.1877 16.2673 37.9361 15.8267 37.662 15.4001C36.9498 14.313 36.1282 13.3018 35.21 12.3821C33.8932 11.0086 32.3117 9.91617 30.561 9.17076C28.8104 8.42536 26.9268 8.04242 25.024 8.04507C15.593 8.04507 8.04803 15.7781 8.04803 27.4731C8.04803 34.4521 11.82 40.6731 18.988 48.0321C20.688 49.7321 26.344 54.8221 26.721 55.1991C27.4943 55.9998 28.313 56.7554 29.173 57.4621C30.305 58.4051 31.436 59.3481 32.573 60.4801C35.025 62.5551 37.854 64.6301 40.495 66.7041C41.061 67.0811 41.438 67.4581 42.004 67.8361C42.4118 67.3012 42.9216 66.8525 43.504 66.5161Z",
      fill: "#6362A7"
    })
  ])
], -1))
const _hoisted_50 = { class: "rk_stareds" }
const _hoisted_51 = ["href"]
const _hoisted_52 = ["src"]
const _hoisted_53 = { class: "titre_carte" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rk_stared_item_heart" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    "data-v-9ea40744": "",
    width: "84",
    height: "76",
    viewBox: "0 0 84 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "data-v-9ea40744": "" }, [
      /*#__PURE__*/_createElementVNode("path", {
        "data-v-9ea40744": "",
        d: "M43.32 7.10007C45.3268 4.97147 47.7556 3.28503 50.4513 2.14857C53.1469 1.01212 56.05 0.45065 58.975 0.500071C72.744 0.500071 83.495 11.6281 83.495 27.4721C83.495 36.9031 78.78 44.8251 70.295 53.3131C68.404 55.2001 62.748 60.2921 62.559 60.4801C61.805 61.2341 60.859 61.9891 59.918 62.9321C58.786 63.8751 57.466 65.0071 56.334 65.9501C53.693 68.2131 50.864 70.2881 48.034 72.3631C47.1182 73.0084 46.2367 73.701 45.393 74.4381C45.0007 74.6662 44.6227 74.918 44.261 75.1921C43.6312 75.6516 42.8717 75.8992 42.092 75.8992C41.3124 75.8992 40.5529 75.6516 39.923 75.1921C39.5614 74.918 39.1833 74.6662 38.791 74.4381C38.037 73.8721 37.091 73.1181 36.15 72.3631C33.321 70.2881 30.491 68.0251 27.85 65.9501C26.53 64.8181 25.398 63.8751 24.266 62.9321C23.323 62.1781 22.566 61.2321 21.625 60.4801C21.248 60.2911 15.589 55.1991 13.703 53.3131C5.03103 44.8251 0.504028 36.9001 0.504028 27.4721C0.504028 11.6281 11.255 0.500071 25.024 0.500071C27.949 0.45065 30.8521 1.01212 33.5478 2.14857C36.2434 3.28503 38.6723 4.97147 40.679 7.10007C41.165 7.49154 41.6076 7.93408 41.999 8.42007C42.3905 7.93408 42.833 7.49154 43.319 7.10007H43.32ZM43.504 66.5161C46.145 64.4411 48.974 62.3661 51.426 60.2921C52.6409 59.3819 53.7782 58.3724 54.826 57.2741C55.6861 56.5674 56.5048 55.8118 57.278 55.0111C57.655 54.6341 63.314 49.5411 65.011 47.8441C72.178 40.6771 75.951 34.4521 75.951 27.4731C75.951 15.7791 68.406 8.04507 58.975 8.04507C55.0833 8.07699 51.3595 9.63461 48.604 12.3831C47.6745 13.2929 46.8509 14.305 46.149 15.4001C45.772 15.9661 45.583 16.5321 45.395 16.7201C45.0943 17.3942 44.6047 17.9668 43.9854 18.3687C43.3661 18.7705 42.6437 18.9843 41.9055 18.9843C41.1673 18.9843 40.4449 18.7705 39.8257 18.3687C39.2064 17.9668 38.7168 17.3942 38.416 16.7201C38.1877 16.2673 37.9361 15.8267 37.662 15.4001C36.9498 14.313 36.1282 13.3018 35.21 12.3821C33.8932 11.0086 32.3117 9.91617 30.561 9.17076C28.8104 8.42536 26.9268 8.04242 25.024 8.04507C15.593 8.04507 8.04803 15.7781 8.04803 27.4731C8.04803 34.4521 11.82 40.6731 18.988 48.0321C20.688 49.7321 26.344 54.8221 26.721 55.1991C27.4943 55.9998 28.313 56.7554 29.173 57.4621C30.305 58.4051 31.436 59.3481 32.573 60.4801C35.025 62.5551 37.854 64.6301 40.495 66.7041C41.061 67.0811 41.438 67.4581 42.004 67.8361C42.4118 67.3012 42.9216 66.8525 43.504 66.5161Z",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rk_selected_contour" }, null, -1))
const _hoisted_56 = { class: "test" }
const _hoisted_57 = {
  key: 3,
  class: "rk_kikekoi_sct"
}
const _hoisted_58 = { class: "rk_container" }
const _hoisted_59 = { class: "rk_c_quoi" }
const _hoisted_60 = ["src"]
const _hoisted_61 = /*#__PURE__*/_createStaticVNode("<svg class=\"rk_quoi_logo\" width=\"382\" height=\"114\" viewBox=\"0 0 382 114\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-5d6ca370><mask id=\"mask0_1_321\" style=\"mask-type:luminance;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"382\" height=\"114\" data-v-5d6ca370><path d=\"M381.972 0.739014H0.0269775V113.106H381.972V0.739014Z\" fill=\"white\" data-v-5d6ca370></path></mask><g mask=\"url(#mask0_1_321)\" data-v-5d6ca370><path d=\"M61.749 80.424C63.504 87.042 66.205 93.253 69.449 97.441H43.379L31.766 56.789C31.6232 56.302 31.3939 55.8447 31.089 55.439L24.608 64.622V74.207C24.5371 82.0982 25.769 89.947 28.254 97.437H0.298978C2.78397 89.947 4.01585 82.0982 3.94498 74.207V32.749C4.05188 24.8766 2.72422 17.0506 0.0269775 9.65399H28.39C25.7996 17.0747 24.5202 24.8896 24.609 32.749V56.112L39.735 32.342C45.273 23.564 46.891 17.621 46.488 9.65399H69.447C61.073 15.462 53.51 24.107 45.81 34.907L35.01 50.034H46.757C51.078 50.034 53.375 50.979 53.916 52.734L61.749 80.424Z\" fill=\"#2A2A2A\" data-v-5d6ca370></path><path d=\"M80.917 79.747V53.681C80.917 48.01 80.782 42.607 77.947 36.396C85.8163 34.2591 93.4597 31.3639 100.77 27.751V79.751C100.77 87.044 101.042 89.612 103.876 97.445H77.947C80.647 89.612 80.917 87.045 80.917 79.751M78.35 12.891C78.35 6.14099 83.35 0.872986 90.642 0.872986C98.203 0.872986 103.201 6.14099 103.201 12.891C103.201 19.51 98.201 24.777 90.642 24.777C83.348 24.777 78.35 19.511 78.35 12.891Z\" fill=\"#2A2A2A\" data-v-5d6ca370></path><path d=\"M170.725 97.439H147.63L139.12 67.591C138.929 66.6233 138.461 65.732 137.772 65.026L133.453 74.614V77.585C133.402 84.2229 133.806 90.8565 134.664 97.439H110.489C113.189 89.606 113.597 84.878 113.597 77.585V27.75C113.597 20.862 113.597 15.459 110.759 9.25001C118.549 7.05543 126.141 4.20836 133.453 0.739014V64.079L136.96 55.839C145.469 35.715 148.709 29.098 162.215 29.098H167.078L165.185 52.998C160.46 50.027 156.949 48.542 153.437 48.542C148.437 48.542 144.386 51.377 139.526 61.508H151.683C156.814 61.508 158.839 62.723 160.596 68.801L165.052 84.201C166.336 88.8499 168.244 93.3032 170.725 97.439Z\" fill=\"#2A2A2A\" data-v-5d6ca370></path><path d=\"M227.306 63.946H192.732C194.218 75.292 199.078 82.313 213.132 82.313C217.949 82.4 222.718 81.3373 227.043 79.213C225.825 87.313 218.262 99.2 202.327 99.2C185.173 99.2 173.019 85.156 173.019 64.086C173.019 43.827 183.553 27.892 203.137 27.892C219.882 27.892 227.312 39.776 227.312 53.957L227.306 63.946ZM207.049 54.357C207.049 39.906 204.349 34.908 200.023 34.908C195.567 34.908 192.323 40.446 192.323 54.898C192.323 56.383 192.323 57.868 192.461 59.354H202.587C206.37 59.354 207.047 59.082 207.047 54.354\" fill=\"#2A2A2A\" data-v-5d6ca370></path><path d=\"M290.007 63.81C290.007 41.39 302.296 27.751 320.26 27.751C335.791 27.751 349.16 40.445 349.16 63.135C349.16 85.69 336.868 99.196 318.771 99.196C303.239 99.196 290.005 86.365 290.005 63.81M328.091 70.293C328.091 52.601 324.715 34.909 318.098 34.909C312.29 34.909 310.939 43.688 310.939 56.654C310.939 74.346 314.315 92.038 320.933 92.038C326.743 92.038 328.091 83.394 328.091 70.293Z\" fill=\"#2A2A2A\" data-v-5d6ca370></path><path d=\"M359.015 79.747V53.681C359.015 48.01 358.88 42.607 356.042 36.396C363.913 34.2592 371.557 31.3639 378.869 27.751V79.751C378.869 87.044 379.137 89.612 381.969 97.445H356.042C358.742 89.612 359.015 87.045 359.015 79.751M356.449 12.891C356.449 6.14099 361.449 0.872986 368.738 0.872986C376.302 0.872986 381.3 6.14099 381.3 12.891C381.3 19.51 376.3 24.777 368.738 24.777C361.447 24.777 356.449 19.511 356.449 12.891Z\" fill=\"#2A2A2A\" data-v-5d6ca370></path><path d=\"M277.541 29.642C278.405 29.6171 279.266 29.7668 280.072 30.082C280.877 30.3973 281.61 30.8717 282.228 31.4768C282.846 32.082 283.336 32.8055 283.668 33.6042C283.999 34.4028 284.167 35.2602 284.16 36.125C284.16 42.338 269.438 54.762 264.71 60.025C269.166 61.645 282.81 65.025 282.81 70.559C282.847 71.3086 282.732 72.0579 282.47 72.7613C282.209 73.4648 281.807 74.1077 281.289 74.6508C280.771 75.194 280.148 75.6261 279.458 75.9208C278.767 76.2155 278.024 76.3666 277.274 76.365C270.791 76.365 264.174 73.53 257.826 71.37C256.478 70.963 255.395 70.558 255.395 72.585C255.476 80.3627 256.109 88.1248 257.288 95.813C257.688 99.866 260.934 103.377 260.934 107.429C260.934 110.4 257.826 113.1 254.856 113.1C240.269 113.1 238.782 64.21 238.782 55.161C238.782 44.361 241.618 0.869995 256.611 0.869995C259.854 0.869995 263.092 3.436 263.092 6.948C262.978 8.50173 262.706 10.0399 262.282 11.539C259.447 20.047 258.094 29.366 257.016 38.55C256.616 41.925 256.204 45.168 259.854 41.521C264.579 36.658 271.467 29.635 277.544 29.635\" fill=\"#6362A7\" data-v-5d6ca370></path></g></svg><p data-v-5d6ca370>c&#39;est quoi ?</p>", 2)
const _hoisted_63 = ["src"]
const _hoisted_64 = { class: "rk_c_quoi_desc" }
const _hoisted_65 = /*#__PURE__*/_createStaticVNode("<svg width=\"130\" height=\"97\" viewBox=\"0 0 130 97\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-5d6ca370><mask id=\"mask0_1_350\" style=\"mask-type:luminance;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"130\" height=\"97\" data-v-5d6ca370><path d=\"M14.7746 96.0785L130 73.6809L115.776 0.506494L0.550971 22.904L14.7746 96.0785Z\" fill=\"white\" data-v-5d6ca370></path></mask><g mask=\"url(#mask0_1_350)\" data-v-5d6ca370><path d=\"M95.2258 45.1795C102.749 49.1184 110.002 53.5517 116.939 58.4503C117.358 58.7272 117.841 58.8905 118.342 58.9244C118.844 58.9582 119.345 58.8614 119.797 58.6434C120.249 58.4253 120.637 58.0936 120.923 57.6806C121.209 57.2676 121.382 56.7874 121.427 56.2872C121.593 51.901 121.876 47.5133 121.988 43.1417C122.058 39.205 122.656 34.7296 121.664 30.928C121.567 30.4977 121.335 30.1098 121.001 29.8214C120.668 29.533 120.25 29.3592 119.81 29.3257C119.371 29.2921 118.932 29.4006 118.558 29.635C118.184 29.8695 117.896 30.2176 117.735 30.6282C116.432 34.3451 116.584 38.7745 116.312 42.7005L116.212 44.9224C115.368 42.5522 114.384 40.2345 113.264 37.9815C110.532 32.4886 106.966 27.4522 102.692 23.0514C98.2472 18.6273 92.9161 15.1945 87.0494 12.9791C81.1826 10.7637 74.9132 9.81588 68.6538 10.198C55.2974 10.8953 42.8057 16.6903 32.6381 25.1977C27.3859 29.6505 22.6296 34.6573 18.4519 40.1309C16.2629 42.9361 14.2497 45.859 12.327 48.86C10.573 51.5552 8.36407 54.3887 7.50843 57.5389C6.97133 59.5921 9.31945 61.5154 11.0866 59.9311C13.2217 58.0226 14.5917 55.4275 16.211 53.0876C18.0179 50.5339 19.8882 48.0442 21.817 45.5932C25.7106 40.5548 30.0797 35.9025 34.8638 31.7005C43.9701 23.8548 55.0721 18.3309 67.1682 17.2714C72.8413 16.7955 78.55 17.5623 83.8965 19.5185C89.2429 21.4746 94.0986 24.5729 98.1251 28.5977C102.061 32.5202 105.403 36.9955 108.048 41.8823C109.032 43.6907 109.889 45.6248 110.761 47.506C106.852 44.849 103.116 41.9048 98.8977 39.7369C95.1849 37.8262 91.4674 43.1809 95.2228 45.1852\" fill=\"#9BCFC3\" data-v-5d6ca370></path></g></svg><p class=\"rk_desc_pres\" data-v-5d6ca370> Notre raison d’être : vous permettre de trouver TOUT ce dont vous avez besoin au plus près de chez vous. </p>", 2)
const _hoisted_67 = ["src"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Partie entraide : vous pourrez recommander des professionnels, demander de l’aide, aider les autres utilisateurs ou même faire du bénévolat et gagner des points", -1))
const _hoisted_69 = ["src"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Professionnels et artisans : KikeKoi est un maxi moteur de recherche qui vous permettra de trouver le prestataire à proximité et recommandé par la communauté de la plateforme", -1))
const _hoisted_71 = ["src"]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Activités et événements : vous pourrez participer aux moments forts à côté de chez vous ", -1))
const _hoisted_73 = ["src"]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Marketplace : cette partie regroupe tous les produits fabriqués localement. Ces produits pourront être commandés en clic & collect", -1))
const _hoisted_75 = {
  key: 4,
  class: "rk_demande_devis"
}
const _hoisted_76 = { class: "rk_container" }
const _hoisted_77 = { class: "rk_demande_devis_cont" }
const _hoisted_78 = { class: "details" }
const _hoisted_79 = { class: "rk_demande_titre" }
const _hoisted_80 = { class: "rk_demande_details" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "rk_k_devis",
  width: "418",
  height: "512",
  viewBox: "0 0 418 512",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20.405 511.002C4.309 400.314 0.937998 286.786 0.697998 243.687V234.587C0.997998 189.962 6.014 94.922 21.929 0H179.479C175.079 28.679 171.412 57.566 168.038 86.3C164.321 117.29 160.59 147.041 194.087 113.573C237.453 68.954 300.672 4.48001 356.457 4.48001C391.149 4.48001 417.213 30.514 417.213 63.98C417.213 121.004 282.086 235.038 238.692 283.389C279.592 298.257 404.792 329.247 404.792 380.076C404.792 407.349 386.207 433.369 353.978 433.369C294.478 433.369 233.749 407.349 175.471 387.525C163.096 383.794 153.155 380.077 153.155 398.677C153.155 435.577 155.183 473.485 158.536 510.997L20.405 511.002Z",
    fill: "white"
  })
], -1))
const _hoisted_82 = ["src"]
const _hoisted_83 = {
  key: 5,
  class: "rk_mise_en_avant"
}
const _hoisted_84 = { class: "rk_container" }
const _hoisted_85 = { class: "rk_titre_section" }
const _hoisted_86 = ["src"]
const _hoisted_87 = { class: "rk_stareds" }
const _hoisted_88 = ["href"]
const _hoisted_89 = ["src", "alt"]
const _hoisted_90 = { class: "titre_carte" }
const _hoisted_91 = {
  key: 6,
  class: "rk_kikekoiPres"
}
const _hoisted_92 = { class: "rk_container" }
const _hoisted_93 = { class: "rk_content" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "rk_k_pres",
  width: "418",
  height: "512",
  viewBox: "0 0 418 512",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M20.405 511.002C4.309 400.314 0.937998 286.786 0.697998 243.687V234.587C0.997998 189.962 6.014 94.922 21.929 0H179.479C175.079 28.679 171.412 57.566 168.038 86.3C164.321 117.29 160.59 147.041 194.087 113.573C237.453 68.954 300.672 4.48001 356.457 4.48001C391.149 4.48001 417.213 30.514 417.213 63.98C417.213 121.004 282.086 235.038 238.692 283.389C279.592 298.257 404.792 329.247 404.792 380.076C404.792 407.349 386.207 433.369 353.978 433.369C294.478 433.369 233.749 407.349 175.471 387.525C163.096 383.794 153.155 380.077 153.155 398.677C153.155 435.577 155.183 473.485 158.536 510.997L20.405 511.002Z",
      fill: "white"
    })
  ])
], -1))
const _hoisted_95 = ["src"]
const _hoisted_96 = /*#__PURE__*/_createStaticVNode("<div data-v-5d6ca370><div data-v-5d6ca370><svg width=\"382\" height=\"113\" viewBox=\"0 0 382 113\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-5d6ca370><mask id=\"mask0_1_2346\" style=\"mask-type:luminance;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"382\" height=\"113\" data-v-5d6ca370><path d=\"M381.945 0H0V112.367H381.945V0Z\" fill=\"white\" data-v-5d6ca370></path></mask><g mask=\"url(#mask0_1_2346)\" data-v-5d6ca370><path d=\"M61.722 79.685C63.477 86.303 66.178 92.514 69.422 96.702H43.352L31.739 56.05C31.5962 55.563 31.3669 55.1057 31.062 54.7L24.581 63.883V73.468C24.5101 81.3592 25.742 89.208 28.227 96.698H0.272C2.75699 89.208 3.98888 81.3592 3.918 73.468V32.01C4.0249 24.1377 2.69724 16.3117 0 8.91504H28.363C25.7726 16.3358 24.4932 24.1507 24.582 32.01V55.373L39.708 31.603C45.246 22.825 46.864 16.882 46.461 8.91504H69.42C61.046 14.723 53.483 23.368 45.783 34.168L34.983 49.295H46.73C51.051 49.295 53.348 50.24 53.889 51.995L61.722 79.685Z\" fill=\"white\" data-v-5d6ca370></path><path d=\"M80.89 79.008V52.942C80.89 47.271 80.755 41.868 77.92 35.657C85.7893 33.5202 93.4328 30.6249 100.743 27.012V79.012C100.743 86.305 101.015 88.873 103.849 96.706H77.92C80.62 88.873 80.89 86.306 80.89 79.012M78.323 12.152C78.323 5.40203 83.323 0.134033 90.615 0.134033C98.176 0.134033 103.174 5.40203 103.174 12.152C103.174 18.771 98.174 24.038 90.615 24.038C83.321 24.038 78.323 18.772 78.323 12.152Z\" fill=\"white\" data-v-5d6ca370></path><path d=\"M170.698 96.7H147.603L139.093 66.852C138.902 65.8842 138.434 64.993 137.745 64.287L133.426 73.875V76.846C133.375 83.4839 133.779 90.1175 134.637 96.7H110.462C113.162 88.867 113.57 84.139 113.57 76.846V27.011C113.57 20.123 113.57 14.72 110.732 8.511C118.522 6.31641 126.114 3.46934 133.426 0V63.34L136.933 55.1C145.442 34.976 148.682 28.359 162.188 28.359H167.051L165.158 52.259C160.433 49.288 156.922 47.803 153.41 47.803C148.41 47.803 144.359 50.638 139.499 60.769H151.656C156.787 60.769 158.812 61.984 160.569 68.062L165.025 83.462C166.309 88.1109 168.217 92.5641 170.698 96.7Z\" fill=\"white\" data-v-5d6ca370></path><path d=\"M227.279 63.207H192.705C194.191 74.553 199.051 81.574 213.105 81.574C217.922 81.661 222.691 80.5983 227.016 78.474C225.798 86.574 218.235 98.461 202.3 98.461C185.146 98.461 172.992 84.417 172.992 63.347C172.992 43.088 183.526 27.153 203.11 27.153C219.855 27.153 227.285 39.037 227.285 53.218L227.279 63.207ZM207.022 53.618C207.022 39.167 204.322 34.169 199.996 34.169C195.54 34.169 192.296 39.707 192.296 54.159C192.296 55.644 192.296 57.129 192.434 58.615H202.56C206.343 58.615 207.02 58.343 207.02 53.615\" fill=\"white\" data-v-5d6ca370></path><path d=\"M289.98 63.071C289.98 40.651 302.269 27.012 320.233 27.012C335.764 27.012 349.133 39.706 349.133 62.396C349.133 84.951 336.841 98.457 318.744 98.457C303.212 98.457 289.978 85.626 289.978 63.071M328.064 69.554C328.064 51.862 324.688 34.17 318.071 34.17C312.263 34.17 310.912 42.949 310.912 55.915C310.912 73.607 314.288 91.299 320.906 91.299C326.716 91.299 328.064 82.655 328.064 69.554Z\" fill=\"white\" data-v-5d6ca370></path><path d=\"M358.988 79.008V52.942C358.988 47.271 358.853 41.868 356.015 35.657C363.886 33.5202 371.53 30.625 378.842 27.012V79.012C378.842 86.305 379.11 88.873 381.942 96.706H356.015C358.715 88.873 358.988 86.306 358.988 79.012M356.422 12.152C356.422 5.40203 361.422 0.134033 368.711 0.134033C376.275 0.134033 381.273 5.40203 381.273 12.152C381.273 18.771 376.273 24.038 368.711 24.038C361.42 24.038 356.422 18.772 356.422 12.152Z\" fill=\"white\" data-v-5d6ca370></path><path d=\"M277.514 28.903C278.378 28.8781 279.239 29.0277 280.045 29.343C280.85 29.6583 281.583 30.1326 282.201 30.7378C282.819 31.343 283.309 32.0665 283.641 32.8652C283.972 33.6638 284.14 34.5211 284.133 35.386C284.133 41.599 269.411 54.023 264.683 59.286C269.139 60.906 282.783 64.286 282.783 69.82C282.82 70.5695 282.705 71.3189 282.443 72.0223C282.182 72.7258 281.78 73.3687 281.262 73.9118C280.744 74.455 280.121 74.8871 279.431 75.1817C278.74 75.4764 277.997 75.6276 277.247 75.626C270.764 75.626 264.147 72.791 257.799 70.631C256.451 70.224 255.368 69.819 255.368 71.846C255.449 79.6236 256.082 87.3858 257.261 95.074C257.661 99.127 260.907 102.638 260.907 106.69C260.907 109.661 257.799 112.361 254.829 112.361C240.242 112.361 238.755 63.471 238.755 54.422C238.755 43.622 241.591 0.130981 256.584 0.130981C259.827 0.130981 263.065 2.69698 263.065 6.20898C262.951 7.76271 262.679 9.30088 262.255 10.8C259.42 19.308 258.067 28.627 256.989 37.811C256.589 41.186 256.177 44.429 259.827 40.782C264.552 35.919 271.44 28.896 277.517 28.896\" fill=\"white\" data-v-5d6ca370></path></g></svg></div><p data-v-5d6ca370>Dans un monde où tout nous éloigne, cette plateforme nous rapproche les uns les autres ! <br data-v-5d6ca370> Loin des yeux mais près du coeur, merci à tout ceux qui ont cru en cette belle aventure qui mêle bienveillance et entraide.<br data-v-5d6ca370> Merci de nous aider à mettre en avant tous ces entrepreneurs qui se lèvent tôt et se saignent tout les jours pour vous apporter des prestations de qualité. </p><a href=\"/\" data-v-5d6ca370>Découvrir la famille KikeKoi</a><div class=\"rk_check_pres\" data-v-5d6ca370><svg width=\"46\" height=\"35\" viewBox=\"0 0 46 35\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-5d6ca370><path d=\"M17.3249 28.696L6.13003 17.5011C5.09944 16.4705 3.42852 16.4705 2.39792 17.5011C1.36733 18.5317 1.36733 20.2026 2.39792 21.2332L13.5928 32.4281C14.6234 33.4587 16.2944 33.4587 17.3249 32.4281C18.3555 31.3975 18.3555 29.7266 17.3249 28.696Z\" fill=\"white\" data-v-5d6ca370></path><path d=\"M39.8697 2.5716L13.747 28.6942C12.7164 29.7248 12.7164 31.3958 13.747 32.4264C14.7776 33.457 16.4486 33.457 17.4791 32.4264L43.6018 6.30371C44.6324 5.27312 44.6324 3.6022 43.6018 2.5716C42.5712 1.54101 40.9003 1.54101 39.8697 2.5716Z\" fill=\"white\" data-v-5d6ca370></path></svg></div></div>", 1)
const _hoisted_97 = {
  key: 7,
  class: "rk_nos_partenaires"
}
const _hoisted_98 = { class: "rk_container" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rk_presentation_partenaires" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createTextVNode("Parce qu'on aime "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" nos partenaires")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "KikeKoi est une grande famille et sans nos partenaires, rien n’aurait été possible. On vous aime")
], -1))
const _hoisted_100 = { class: "rk_partenaire" }
const _hoisted_101 = ["src"]
const _hoisted_102 = {
  key: 0,
  class: "popup"
}
const _hoisted_103 = { class: "rk_container" }

import { onBeforeMount, onMounted, ref, watch } from 'vue'
import { useLoginStore } from '../store/piniaLogin'
import { useModalStore } from '../store/piniaModals'
import { useEntraideStore } from '../store/piniaEntraide'
import "leaflet/dist/leaflet.css";
import axios from "axios";
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from "@vue-leaflet/vue-leaflet";
import marketPlace from '../components/produits/marketplaceView.vue'
import eventPlace from '../components/evenements/eventsView.vue'

import entraideCards from '../components/entraide/entraideView.vue'
import welcomeModal from '../components/modals/welcomeModal.vue'
import contactModal from '../components/modals/contactModal.vue'

import { toast } from 'vue3-toastify';
import { storeToRefs } from 'pinia';

import keyword_extractor from 'keyword-extractor';
import LazyList from 'lazy-load-list/vue'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
const zoom = 11;

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const modalStore = useModalStore();
const store = useLoginStore()
const entraideStore = useEntraideStore()

const { currentLatlng, selectedPart, hasScrolled, activeMaps, searchProduit } = storeToRefs(store)

const filters = ref([]);
const search = ref('');
const changeService = ref();
const changeCat = ref();
const selectCat = ref();

const map = ref();
const searched = ref(0);
const loadVideo = ref(false);

const showMap = ref(true);
// const showModal = ref(false);
// const showdevisModal = ref(false);

const serverUrl = ref(process.env.VUE_APP_SERVER_URL);
const categories = ref([]);
const partenaires = ref();
const services = ref([]);
const prestaList = ref([]);
const kikekoi_form_focus = ref(1);
function changeFocus(nb) {
  kikekoi_form_focus.value = nb;
}




const mapCenter = ref([45.692341, 5.908998]);
const UserMapCenter = ref([45.692341, 5.908998]);

const jecherche = ref("Owl formations");
const placeholders = ['Coiffeur', 'électricien', 'nounou', 'Déménagement', 'Site internet', 'Logo'];
function changePlaceholder() {
  const rand = Math.floor(Math.random() * placeholders.length);
  jecherche.value = placeholders[rand];
}


partenaires.value = [
  {
    logo: 'https://lesiteeco.com/wp-content/uploads/2017/12/logo-site-eco-couleurs.png',
    titre: 'Le site eco',
    presentation: 'Le Site Éco est une communauté souriante qui offre un espace de travail stimulant avec un réseau de membres riche et diversifié.'
  },
  {
    logo: 'https://www.sweepen.com/wp-content/uploads/2023/06/Logo-couleur.png',
    titre: 'Sweepen',
    presentation: "Le réseau social Sweepen pour les passionnés du sport arrive à l’automne 2023.Financements, événements, résultats et actualités de vos sportifs préférés à venir !"
  },
  {
    logo: 'https://media.licdn.com/dms/image/C4E0BAQEet2mPPE5jUg/company-logo_200_200/0/1675433095757?e=1703116800&v=beta&t=4YilHyCMjmC5sgaYj4NHUvWmXnJEgZFB4BOnLltKYLI',
    titre: 'La french tech MONT BLANC',
    presentation: "La communauté French Tech Mont Blanc, labellisée par le gouvernement, pilote l'initiative French Tech sur le territoire haut savoyard, de Cluses à Chamonix."
  },
  // { logo: 'https://lesiteeco.com/wp-content/uploads/2017/12/logo-site-eco-couleurs.png', presentation: 'lorem ipsum bla bla bla bla bal balfazdl zale laze zae !' },
  // { logo: 'https://lesiteeco.com/wp-content/uploads/2017/12/logo-site-eco-couleurs.png', presentation: 'lorem ipsum bla bla bla bla bal balfazdl zale laze zae !' },
  // { logo: 'https://lesiteeco.com/wp-content/uploads/2017/12/logo-site-eco-couleurs.png', presentation: 'lorem ipsum bla bla bla bla bal balfazdl zale laze zae !' },
  // { logo: 'https://lesiteeco.com/wp-content/uploads/2017/12/logo-site-eco-couleurs.png', presentation: 'lorem ipsum bla bla bla bla bal balfazdl zale laze zae !' },
]

onBeforeMount(() => {
  if (currentLatlng.value.lat !== '' && currentLatlng.value.lng !== '') {
    loadAround('prestataires');
    setTimeout(() => {
      loadAround('entraide');

    }, 3000);
    loadVideo.value = true;

  } else {

    setTimeout(() => {
      loadVideo.value = true;

    }, 5000);
  }

})

onMounted(() => {

  setInterval(() => {
    changePlaceholder()
  }, 3000);



})
watch(activeMaps, () => {
  mapCenter.value = UserMapCenter.value;
  showMap.value = false;

  setTimeout(() => {
    showMap.value = true;
  }, 410);
}),


  watch(selectedPart, (value) => {
    mapCenter.value = UserMapCenter.value;
    showMap.value = false;

    if (value === 0 && prestaList.value.length == 0) {

      homeDatas.value[1].markers.forEach(presta => {
        prestaList.value.push({ label: presta.nomEntreprise, value: presta._id })
      });
      entraideStore.addEntraidePresta(prestaList.value)


    }


    setTimeout(() => {
      showMap.value = true;
      activeMaps.value = true;

    }, 410);
  }),

  watch(currentLatlng, () => {

    loadAround('prestataires');
    setTimeout(() => {
      loadAround('entraide');

    }, 3000);
  }),

  watch(changeService, (value) => {

    if (value == undefined && changeCat.value == undefined) {
      homeDatas.value[1].markersFiltered = homeDatas.value[1].markers;


    } else {
      activeMaps.value = true;
      homeDatas.value[1].markersFiltered = homeDatas.value[1].markers.filter((obj) =>
        obj.servicesPresta.some((service) => service.services._id === value)
      );
    }
  }),

  watch(selectCat, (value) => {

    if (value == undefined && changeService.value == undefined) {
      homeDatas.value[1].markersFiltered = homeDatas.value[1].markers;

    } else {
      activeMaps.value = true;
      homeDatas.value[1].markersFiltered = homeDatas.value[1].markers.filter((obj) =>
        obj.categories.some((categorie) => categorie._id === value));
    }

  }),
  watch(changeCat, (value) => {

    if (value == undefined && changeService.value == undefined) {
      homeDatas.value[1].markersFiltered = homeDatas.value[1].markers;

    } else {
      activeMaps.value = true;
      homeDatas.value[1].markersFiltered = homeDatas.value[1].markers.filter((obj) =>
        obj.categories.some((categorie) => categorie._id === value));
    }

  }),





  watch(search, (value) => {
    activeMaps.value = true;
    const extraction_result =
      keyword_extractor.extract(value, {
        language: "french",
        remove_digits: true,
        return_changed_case: true,
        remove_duplicates: true
      });

    if (extraction_result.length > 0 || value.length > 2) {
      filters.value = extraction_result;

      homeDatas.value[1].markersFiltered = filterDatas(extraction_result, homeDatas.value[1].markers);
      searched.value++;
    } else {
      searched.value++;

      homeDatas.value[1].markersFiltered = homeDatas.value[1].markers

    }



  })

function loadAround(route) {
  let token = '';
  let index = 1;

  switch (route) {
    case 'entraide':
      index = 0;
      break;

    case 'prestataires':
      index = 1;
      break;

    case 'activites':
      index = 2;
      break;
    case 'produits':
      index = 3;
      break;
  }
  const params = ref({
    lat: 45.692341,
    long: 5.908998
  });



  if (store.currentToken !== undefined && store.currentToken !== 'false' && store.currentToken !== '') {

    const localUser = JSON.parse(store.currentUser);
    token = store.currentToken;

    params.value.lat = localUser.location.coordinates[1];
    params.value.long = localUser.location.coordinates[0];



  } else if (currentLatlng.value.lat !== '' && currentLatlng.value.lng !== '') {

    params.value = {
      lat: currentLatlng.value.lat,
      long: currentLatlng.value.lng
    };

    mapCenter.value = [currentLatlng.value.lat, currentLatlng.value.lng];

    UserMapCenter.value = mapCenter.value;
  }

  axios.get(process.env.VUE_APP_SERVER_URL + `/${route}/autour`, {
    withCredentials: true,

    params: params.value,
    headers: {
      'Authorization': `Basic ${token}`
    }
  })
    .then(function (response) {
      // handle success
      if (response.data.user !== false) {

        store.setUser(response.data.user);
        store.setToken(response.data.user.token);
      }
      response.data.datas.forEach(marker => {
        marker.hover = false;
        marker.iconUrl = serverUrl.value + '/uploads/kikekoi/map-icon-green.svg';
        // je multiplie le contenu

        homeDatas.value[index].markers.push(marker)
        if (route == 'prestataires') {
          marker.servicesPresta.forEach(service => {
            if (!services.value.some(s => s._id === service.services._id)) {

              services.value.push({ 'label': service.services.titre, 'value': service.services._id, '_id': service.services._id });
            }
          });

          marker.categories.forEach(categorie => {
            if (!categories.value.some(s => s._id === categorie._id)) {

              categories.value.push({ 'label': categorie.titre, 'icon': categorie.icons, '_id': categorie._id, 'value': categorie._id });
            }
          });
        }


        if (route == 'entraide') {

          entraideStore.setEntraideList(homeDatas.value[index].markers);

        }
        store.setServices(services.value);

        store.setCategories(categories.value);
      });




      homeDatas.value[index].markersFiltered = homeDatas.value[index].markers;


    })
    .catch(function (error) {
      // handle error
      console.log(error);

      toast.error(error);
    })
}





function filterDatas(value, datas) {
  const result = [];
  for (let i = 0; i < datas.length; i++) {
    const obj = datas[i];
    const { presentation, nomEntreprise, shortPresentation, servicesPresta } = obj;
    const found = [presentation, nomEntreprise, shortPresentation];
    for (let j = 0; j < servicesPresta.length; j++) {
      const service = servicesPresta[j];
      found.push(service.services.titre);
    }
    const foundAny = found.some(text => {
      return value.some(query => text.toLowerCase().includes(query));
    });
    if (foundAny) {
      result.push(obj);
    }
  }
  return result;
}

function clickMarker(e, out = false) {
  const index = homeDatas.value[1].markersFiltered.map(function (e) { return e.slug; }).indexOf(e.slug);
  mapCenter.value = [e.location.coordinates[1], e.location.coordinates[0]];

  if (out == true) {
    homeDatas.value[1].markersFiltered[index].hover = false;

    homeDatas.value[1].markersFiltered[index].iconUrl = serverUrl.value + '/uploads/kikekoi/map-icon-green.svg';
  } else {
    homeDatas.value[1].markersFiltered[index].hover = true;

    homeDatas.value[1].markersFiltered[index].iconUrl = serverUrl.value + '/uploads/kikekoi/map-icon-violet.svg';

  }

  // setTimeout(() => {
  //   document.querySelectorAll('.leaflet-marker-pane img')[index].click();

  // }, 400);


}

function scrollTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });

}



const homeDatas = ref([
  {
    titre: 'Entraide',
    markers: [],
    markersFiltered: []
  },
  {
    titre: 'Prestataires',
    titreCategories: "Voir nos prestataires par domaine d'activité",
    enAvantTitle: 'Nos pros en avant',
    enAvant: [
      { img: serverUrl.value + '/uploads/kikekoi/presta_1.webp', nom: 'Pourquoi pas votre entreprise ?', url: '' },
      { img: serverUrl.value + '/uploads/kikekoi/presta_2.webp', nom: 'Pourquoi pas votre entreprise ?', url: '' },
      { img: serverUrl.value + '/uploads/kikekoi/presta_3.webp', nom: 'Pourquoi pas votre entreprise ?', url: '' },
      { img: serverUrl.value + '/uploads/kikekoi/presta_7.webp', nom: 'Pourquoi pas votre entreprise ?', url: '' },
      { img: serverUrl.value + '/uploads/kikekoi/presta_5.webp', nom: 'Pourquoi pas votre entreprise ?', url: '' },
      { img: serverUrl.value + '/uploads/kikekoi/presta_8.webp', nom: 'Pourquoi pas votre entreprise ?', url: '' }
    ],

    offre: {
      title: 'Apparaître sur kikeKoi en deux clics ?',
      desc: 'Professionnels, optimisez votre visibilité et développez votre clientèle avec KikeKoi ! Vous avez deux possibilités : créez votre compte en quelques clics ou laissez-nous vous assister en remplissant notre formulaire, et nous nous occupons du reste.',
      titreBtn: 'Je deviens prestataire de KikeKoi',
      urlImg: serverUrl.value + '/uploads/kikekoi/offre_presta.webp'
    },
    enAvantBisTitle: 'Les plus recommandés',
    enAvantBis: [
      { img: serverUrl.value + '/uploads/kikekoi/presta_1.webp', desc: 'Blabla bla', nom: 'Kévin', url: '' },
      { img: serverUrl.value + '/uploads/kikekoi/presta_2.webp', desc: 'Blabla bla', nom: 'Fanny', url: '' },
      { img: serverUrl.value + '/uploads/kikekoi/presta_3.webp', desc: 'Blabla bla', nom: 'Murielle', url: '' },
      { img: serverUrl.value + '/uploads/kikekoi/presta_4.webp', desc: 'Blabla bla', nom: 'Florian', url: '' },
      { img: serverUrl.value + '/uploads/kikekoi/presta_5.webp', desc: 'Blabla bla', nom: 'Julie', url: '' },
      { img: serverUrl.value + '/uploads/kikekoi/presta_6.webp', desc: 'Blabla bla', nom: 'Danh', url: '' }
    ],
    markers: [

    ],
    markersFiltered: []
  },
  {
    titre: 'Activités',
    markers: [],
    markersFiltered: []
  },
  {
    titre: 'Produits locaux',
    markers: [],
    markersFiltered: []
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("div", {
        class: _normalizeClass(["kikekoi_form", [{ sticky: (_unref(hasScrolled) && _unref(selectedPart) !== 3) }, { unsticky: (!_unref(hasScrolled) || _unref(selectedPart) == 3) }, { marketPlace: (_unref(selectedPart) == 3) }]])
      }, [
        (_unref(selectedPart) == 1 && _unref(activeMaps))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: _normalizeClass(["form_item input1", [{ focused: (kikekoi_form_focus.value == 1) }]])
              }, [
                _createVNode(_component_FormKit, {
                  type: "search",
                  label: "Je recherche",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (changeFocus(1))),
                  id: "rk_search_input",
                  placeholder: jecherche.value,
                  modelValue: search.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event))
                }, null, 8, ["placeholder", "modelValue"])
              ], 2),
              _createElementVNode("div", { class: "form_item input4" }, [
                _createElementVNode("label", {
                  class: "form_item form_button",
                  onClick: scrollTop,
                  for: "rk_search_input"
                }, _hoisted_3)
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(selectedPart) == 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["form_item input1", [{ focused: (kikekoi_form_focus.value == 1) }]])
              }, [
                _createVNode(_component_FormKit, {
                  type: "search",
                  label: "Quel produit cherchez-vous?",
                  id: "rk_search_input_shop",
                  placeholder: "Savon, miel,etc ...",
                  modelValue: _unref(searchProduit),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(searchProduit) ? (searchProduit).value = $event : null))
                }, null, 8, ["modelValue"])
              ], 2),
              _createElementVNode("div", { class: "form_item input4" }, [
                _createElementVNode("label", {
                  class: "form_item form_button",
                  onClick: scrollTop,
                  for: "rk_search_input_shop"
                }, _hoisted_6)
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(selectedPart) == 7)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _createElementVNode("div", { class: "form_item input4" }, [
                _createElementVNode("label", {
                  class: "form_item form_button",
                  onClick: scrollTop,
                  for: "rk_search_input"
                }, _hoisted_12)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (_unref(selectedPart) == 1 && _unref(activeMaps) || _unref(selectedPart) == 3)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["kikekoi_form_mobile", [{ sticky: (_unref(hasScrolled) && _unref(selectedPart) !== 3) }, { unsticky: (!_unref(hasScrolled) || _unref(selectedPart) == 3) }, { marketPlace: (_unref(selectedPart) == 3) }]])
          }, [
            (_unref(selectedPart) == 1 && _unref(activeMaps))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", { class: "form_item input4" }, [
                    _createElementVNode("label", {
                      class: "form_item form_button",
                      onClick: scrollTop,
                      for: "rk_search_input_mobile"
                    }, _hoisted_15)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form_item input1", [{ focused: (kikekoi_form_focus.value == 1) }]])
                  }, [
                    _createVNode(_component_FormKit, {
                      type: "search",
                      label: "Je recherche",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (changeFocus(1))),
                      id: "rk_search_input_mobile",
                      placeholder: jecherche.value,
                      modelValue: search.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((search).value = $event))
                    }, null, 8, ["placeholder", "modelValue"])
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (_unref(selectedPart) == 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", { class: "form_item input4" }, [
                    _createElementVNode("label", {
                      class: "form_item form_button",
                      onClick: scrollTop,
                      for: "rk_search_input_shop_mobile"
                    }, _hoisted_18)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form_item input1", [{ focused: (kikekoi_form_focus.value == 1) }]])
                  }, [
                    _createVNode(_component_FormKit, {
                      type: "search",
                      label: "Quel produit cherchez-vous?",
                      id: "rk_search_input_shop_mobile",
                      placeholder: "Savon, miel,etc ...",
                      modelValue: _unref(searchProduit),
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(searchProduit) ? (searchProduit).value = $event : null))
                    }, null, 8, ["modelValue"])
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (_unref(selectedPart) == 7)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22,
                  _createElementVNode("div", { class: "form_item input4" }, [
                    _createElementVNode("label", {
                      class: "form_item form_button",
                      onClick: scrollTop,
                      for: "rk_search_input"
                    }, _hoisted_24)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", {
      class: _normalizeClass(["home_content", { popup: (_unref(currentLatlng).lat == '' && _unref(currentLatlng).lng == '') }])
    }, [
      (_unref(selectedPart) == 1 && _unref(activeMaps))
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createVNode(_unref(VueperSlides), {
              lazy: "",
              class: "no-shadow",
              touchable: false,
              arrows: true,
              bullets: false,
              "visible-slides": 8,
              "fixed-height": "110px",
              "slide-multiple": "",
              breakpoints: {
          750: { visibleSlides: 4, draggingDistance: '70px', slideMultiple: false, arrows: false, touchable: true, fixedHeight: '120px' }
        }
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (categorie, i) => {
                  return (_openBlock(), _createBlock(_unref(VueperSlide), {
                    class: "rk_slides",
                    key: i
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["rk_cat_change", { active: (selectCat.value == categorie._id || changeCat.value == categorie._id) }]),
                        onClick: ($event: any) => (selectCat.value = categorie._id)
                      }, [
                        _createElementVNode("img", {
                          loading: "lazy",
                          src: serverUrl.value + '/uploads/kikekoi/icones/' + categorie.icon + '.svg',
                          alt: 'Icône de la catégorie ' + categorie.label
                        }, null, 8, _hoisted_27),
                        _createElementVNode("p", null, _toDisplayString(categorie.label), 1)
                      ], 10, _hoisted_26)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["main", { fullpage: (_unref(selectedPart) == 4 || _unref(selectedPart) == 3 || _unref(selectedPart) == 2), nopage: (_unref(selectedPart) == 0) }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([{ active: (!_unref(activeMaps) && _unref(selectedPart) == 1) }, "rk_container search"])
        }, [
          _createElementVNode("div", _hoisted_28, [
            (loadVideo.value)
              ? (_openBlock(), _createElementBlock("video", _hoisted_29, [
                  _createElementVNode("source", {
                    src: serverUrl.value + '/uploads/kikekoi/kikekoi.mp4',
                    type: "video/mp4"
                  }, null, 8, _hoisted_30)
                ]))
              : _createCommentVNode("", true),
            _hoisted_31,
            _createElementVNode("div", {
              class: "show_map",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(store).setActiveMaps(!_unref(activeMaps))))
            }, [
              _createElementVNode("img", {
                loading: "lazy",
                src: serverUrl.value + '/uploads/kikekoi/map-icon-green.svg',
                alt: "icone marker"
              }, null, 8, _hoisted_32)
            ])
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass([{ active: _unref(activeMaps) }, "rk_container two maps"])
        }, [
          (showMap.value)
            ? (_openBlock(), _createBlock(_unref(LMap), {
                key: 0,
                ref_key: "map",
                ref: map,
                zoom: zoom,
                "onUpdate:zoom": _cache[7] || (_cache[7] = ($event: any) => ((zoom) = $event)),
                options: { scrollWheelZoom: false },
                center: mapCenter.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(LTileLayer), {
                    url: "https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png",
                    "layer-type": "base",
                    name: "OpenStreetMap"
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(homeDatas.value[_unref(selectedPart)].markersFiltered, (marker) => {
                    return (_openBlock(), _createBlock(_unref(LMarker), {
                      class: _normalizeClass('rk_' + marker.slug),
                      key: marker.titre,
                      "lat-lng": [marker.location.coordinates[1], marker.location.coordinates[0]]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(LPopup), { class: "rk_map_popup" }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              loading: "lazy",
                              src: serverUrl.value + marker.logo
                            }, null, 8, _hoisted_33),
                            _createElementVNode("h3", null, _toDisplayString(marker.nomEntreprise), 1),
                            _createVNode(_component_router_link, {
                              to: '/presta/' + marker.slug
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Voir la fiche ")
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_unref(LIcon), {
                          className: marker.hover ? 'icon_hover' : '',
                          "icon-anchor": [0, 32],
                          "icon-size": [32, 32],
                          "icon-url": marker.iconUrl
                        }, null, 8, ["className", "icon-url"])
                      ]),
                      _: 2
                    }, 1032, ["class", "lat-lng"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["center"]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["resultats", { active: (_unref(activeMaps) || _unref(selectedPart) !== 1), one: (_unref(selectedPart) == 4), two: (_unref(selectedPart) == 1), three: (_unref(selectedPart) == 0), four: (_unref(selectedPart) == 3), five: (_unref(selectedPart) == 2) }])
        }, [
          _createElementVNode("div", {
            class: "close_map",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (activeMaps.value = !_unref(activeMaps)))
          }),
          (_unref(selectedPart) == 1 && _unref(activeMaps))
            ? (_openBlock(), _createElementBlock("h2", _hoisted_34, "Prestataires des alentours:"))
            : _createCommentVNode("", true),
          (_unref(selectedPart) == 0 && _unref(activeMaps))
            ? (_openBlock(), _createElementBlock("h2", _hoisted_35, "Parce que l’entraide est une force ! "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_TransitionGroup, {
              name: "nested",
              tag: "div",
              class: "rk_order"
            }, {
              default: _withCtx(() => [
                (homeDatas.value[_unref(selectedPart)].markersFiltered.length > 0 && _unref(selectedPart) == 1)
                  ? (_openBlock(), _createBlock(_unref(LazyList), {
                      key: searched.value,
                      data: homeDatas.value[_unref(selectedPart)].markersFiltered,
                      itemsPerRender: 13,
                      containerClasses: "list",
                      defaultLoadingColor: "#222"
                    }, {
                      default: _withCtx(({ item }) => [
                        _createVNode(_component_router_link, {
                          onMouseenter: ($event: any) => (clickMarker(item)),
                          onMouseleave: ($event: any) => (clickMarker(item, true)),
                          to: '/presta/' + item.slug,
                          class: "element"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              loading: "lazy",
                              src: serverUrl.value + item.logo
                            }, null, 8, _hoisted_37),
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("p", _hoisted_39, _toDisplayString(item.nomEntreprise), 1),
                              _createElementVNode("p", _hoisted_40, _toDisplayString(item.shortPresentation), 1),
                              _createElementVNode("p", _hoisted_41, [
                                _createElementVNode("img", {
                                  loading: "lazy",
                                  src: serverUrl.value + '/uploads/kikekoi/map-icon-green.svg',
                                  alt: "icone marker"
                                }, null, 8, _hoisted_42),
                                _createTextVNode(" " + _toDisplayString(item.contact.ville), 1)
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onMouseenter", "onMouseleave", "to"])
                      ]),
                      _: 1
                    }, 8, ["data"]))
                  : (_unref(selectedPart) == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_unref(selectedPart) == 2)
              ? (_openBlock(), _createBlock(eventPlace, { key: 0 }))
              : _createCommentVNode("", true),
            (_unref(selectedPart) == 3)
              ? (_openBlock(), _createBlock(marketPlace, { key: 1 }))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ], 2),
      (_unref(selectedPart) == 0)
        ? (_openBlock(), _createBlock(entraideCards, { key: 1 }))
        : _createCommentVNode("", true),
      (_unref(selectedPart) == 1 && !_unref(activeMaps))
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createTextVNode(" " + _toDisplayString(homeDatas.value[_unref(selectedPart)].enAvantTitle), 1)
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_unref(VueperSlides), {
                  lazy: "",
                  class: "no-shadow",
                  autoplay: "",
                  infinite: true,
                  arrows: false,
                  "bullets-outside": "",
                  "visible-slides": 3,
                  slideMultiple: false,
                  breakpoints: { 800: { visibleSlides: 2, slideRatio: 1 / 1 } }
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(homeDatas.value[_unref(selectedPart)].enAvant, (stared, i) => {
                      return (_openBlock(), _createBlock(_unref(VueperSlide), { key: i }, {
                        content: _withCtx(() => [
                          (_openBlock(), _createElementBlock("a", {
                            key: stared.nom,
                            href: stared.url,
                            class: "rk_stared_item"
                          }, [
                            _createElementVNode("img", {
                              loading: "lazy",
                              src: stared.img,
                              alt: ""
                            }, null, 8, _hoisted_52),
                            _createElementVNode("span", _hoisted_53, _toDisplayString(stared.nom), 1),
                            _hoisted_54,
                            _hoisted_55
                          ], 8, _hoisted_51))
                        ]),
                        bullet: _withCtx(({ index }) => [
                          _createElementVNode("span", _hoisted_56, _toDisplayString(index), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(selectedPart) == 1 && !_unref(activeMaps))
        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("img", {
                  loading: "lazy",
                  class: "rk_k",
                  src: serverUrl.value + '/uploads/kikekoi/image_K.svg',
                  alt: "Logo K kikekoi"
                }, null, 8, _hoisted_60),
                _hoisted_61,
                _createElementVNode("img", {
                  loading: "lazy",
                  src: serverUrl.value + '/uploads/kikekoi/image_telephone.svg',
                  alt: "image d'un téléphone avec une map",
                  class: "rk_phone_svg"
                }, null, 8, _hoisted_63)
              ]),
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("img", {
                      loading: "lazy",
                      src: serverUrl.value + '/uploads/kikekoi/icones/entraide.svg',
                      alt: "Icône de la partie entraide"
                    }, null, 8, _hoisted_67),
                    _hoisted_68
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("img", {
                      loading: "lazy",
                      src: serverUrl.value + '/uploads/kikekoi/icones/prestataires.svg',
                      alt: "Icône de la partie prestataires "
                    }, null, 8, _hoisted_69),
                    _hoisted_70
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("img", {
                      loading: "lazy",
                      src: serverUrl.value + '/uploads/kikekoi/icones/activités.svg',
                      alt: "Icône de la partie événements"
                    }, null, 8, _hoisted_71),
                    _hoisted_72
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("img", {
                      loading: "lazy",
                      src: serverUrl.value + '/uploads/kikekoi/icones/produits.svg',
                      alt: "Icône de la marketplace"
                    }, null, 8, _hoisted_73),
                    _hoisted_74
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(selectedPart) == 1 && !_unref(activeMaps))
        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("h3", _hoisted_79, _toDisplayString(homeDatas.value[_unref(selectedPart)].offre.title), 1),
                  _createElementVNode("span", _hoisted_80, _toDisplayString(homeDatas.value[_unref(selectedPart)].offre.desc), 1),
                  _createElementVNode("div", {
                    class: "rk_demande_btn",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(modalStore).setCurrentModal('presta', true)))
                  }, _toDisplayString(homeDatas.value[_unref(selectedPart)].offre.titreBtn), 1),
                  _hoisted_81
                ]),
                _createElementVNode("img", {
                  loading: "lazy",
                  src: homeDatas.value[_unref(selectedPart)].offre.urlImg,
                  alt: ""
                }, null, 8, _hoisted_82)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(selectedPart) == 1 && !_unref(activeMaps))
        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("h2", _hoisted_85, [
                _createTextVNode(_toDisplayString(homeDatas.value[_unref(selectedPart)].enAvantBisTitle) + " ", 1),
                _createElementVNode("img", {
                  loading: "lazy",
                  src: serverUrl.value + '/uploads/kikekoi/icon-map.svg',
                  alt: "icone map"
                }, null, 8, _hoisted_86)
              ]),
              _createElementVNode("div", _hoisted_87, [
                _createVNode(_unref(VueperSlides), {
                  "fixed-height": "350px",
                  lazy: "",
                  class: "no-shadow",
                  "disable-arrows-on-edges": "",
                  bullets: true,
                  "visible-slides": 5,
                  arrows: false,
                  "slide-multiple": "",
                  slideRatio: 1 / 1,
                  breakpoints: { 1280: { slideRatio: 1 / 1, visibleSlides: 3, slideMultiple: 1 }, 800: { slideRatio: 1 / 1, visibleSlides: 2, slideMultiple: 2 } }
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(homeDatas.value[_unref(selectedPart)].enAvantBis, (staredBis) => {
                      return (_openBlock(), _createBlock(_unref(VueperSlide), {
                        class: "rk_slides",
                        key: staredBis.nom
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("a", {
                            class: "rk_stared_item popular",
                            href: staredBis.url
                          }, [
                            _createElementVNode("img", {
                              loading: "lazy",
                              src: staredBis.img,
                              alt: 'image de ' + staredBis.nom
                            }, null, 8, _hoisted_89),
                            _createElementVNode("span", _hoisted_90, _toDisplayString(staredBis.nom), 1)
                          ], 8, _hoisted_88)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(selectedPart) == 1 && !_unref(activeMaps))
        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("div", _hoisted_93, [
                _hoisted_94,
                _createElementVNode("img", {
                  loading: "lazy",
                  src: serverUrl.value + '/uploads/kikekoi/presentation_kikekoi.webp',
                  alt: "Photo de présentaiton de kikekoi"
                }, null, 8, _hoisted_95),
                _hoisted_96
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(selectedPart) == 1 && !_unref(activeMaps))
        ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _hoisted_99,
              _createElementVNode("div", null, [
                _createVNode(_unref(VueperSlides), {
                  lazy: "",
                  class: "no-shadow",
                  "disable-arrows-on-edges": "",
                  bullets: false,
                  "visible-slides": 3,
                  "slide-multiple": "",
                  arrows: false,
                  "slide-ratio": 0.4,
                  breakpoints: {
              800: {
                visibleSlides: 2, slideMultiple: 1, slideRatio: 0.6
              }
            }
              
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partenaires.value, (partenaire, i) => {
                      return (_openBlock(), _createBlock(_unref(VueperSlide), {
                        class: "rk_slides",
                        key: i
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_100, [
                            _createElementVNode("img", {
                              loading: "lazy",
                              src: partenaire.logo,
                              alt: "logo partenaire"
                            }, null, 8, _hoisted_101),
                            _createElementVNode("p", null, _toDisplayString(partenaire.presentation), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_unref(currentLatlng).lat == '' && _unref(currentLatlng).lng == '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
          _createElementVNode("div", _hoisted_103, [
            _createVNode(welcomeModal)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(contactModal)
    ]))
  ], 64))
}
}

})